import { RouterModule, Routes } from "@angular/router";
import { AnonymousAppComponent } from "./anonymous-app/anonymous-app.component";
import { AuthenAppComponent } from "./authen-app/authen-app.component";
import { FaqComponent } from "./faq/faq.component";

const routes: Routes = [
    {
        path: "",
        component: AnonymousAppComponent,
        children: [
            {
                path: "",
                redirectTo: "sktqdn",
                pathMatch: "full",
            },
            {
                path: "sktqdn",
                loadChildren: () =>
                    import("./pages/home-page.module").then(
                        (m) => m.HomePageModule
                    ),
            },
            {
                path: "sktqdn/tai-khoan/dang-ky",
                loadChildren: () =>
                    import("./pages/tai-khoan-page.module").then(
                        (m) => m.TaiKhoanPageModule
                    ),
            },
            {
                path: "sktqdn/faq",
                component: FaqComponent,
            },
        ],
    },
    {
        path: "sktqdn/authen",
        component: AuthenAppComponent,
        children: [
            {
                path: "dang-ky-kham",
                loadChildren: () =>
                    import("./pages/dang-ky-kham-page.module").then(
                        (m) => m.DangKyKhamPageModule
                    ),
            },
            {
                path: "tra-cuu",
                loadChildren: () =>
                    import("./pages/tra-cuu-page.module").then(
                        (m) => m.TraCuuPageModule
                    ),
            },
            {
                path: "ket-qua-kham",
                loadChildren: () =>
                    import("./pages/ket-qua-kham-page.module").then(
                        (m) => m.KetQuaKhamPageModule
                    ),
            },
            {
                path: "tinh-trang-kham",
                loadChildren: () =>
                    import("./pages/tinh-trang-kham-page.module").then(
                        (m) => m.TinhTrangKhamPageModule
                    ),
            },
        ],
    },
    { path: "**", redirectTo: "/sktqdn", pathMatch: "full" },
];
export const AppRoutes = RouterModule.forRoot(routes);
